jQuery(document).ready(function($){
  if($('body').hasClass('blog-recipes')){
    var showcnt=0;
    var originalHtml='';
    originalHtml = $('.filter_products_div').html();
  }
  $('.size-options a').on('click', function(event){
    event.preventDefault();
    // Handle the filter nav buttons -------------->
    // remove not filtering indicator class if present, and add filtering indicator class
    $(this).removeClass('js-not-filtering').addClass('js-current-filter');
    // add not filtering class to rest of buttons
    $(this).siblings('.size-filter-option').removeClass('js-current-filter').addClass('js-not-filtering');
    // Handle the products to filter -------------->
    // grab the variant title and make it the filter value
    var filteringBy = $(this).attr('data-foodtime');
    filteringBy = "foodtime-" + filteringBy;
    var allresult='';
    AOS.refreshHard()
    console.log(filteringBy);
    if(filteringBy == 'foodtime-All') {
      $('.js-size-filter').removeClass('hide');
      $('.filter_products_div').html(originalHtml);
    } else {
      $('.js-size-filter').each(function() {
        //   originalHtml +='<div class="'+$(this).attr('class')+'">'+$(this).html()+'</div>';
        if(!$(this).hasClass(filteringBy)) {
          $(this).removeClass('active-filter');
          $(this).addClass('hide');
        } else {
          $(this).removeClass('hide');
          $(this).addClass('active-filter');
        }
      });  
    }
  });
});